import { render } from "./configurations.vue?vue&type=template&id=394a68d4&scoped=true"
import script from "./configurations.vue?vue&type=script&lang=js"
export * from "./configurations.vue?vue&type=script&lang=js"

import "./configurations.vue?vue&type=style&index=0&id=394a68d4&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394a68d4"]])

export default __exports__